import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

class Requestgame extends Component {
  static propTypes = {
    options: PropTypes.instanceOf(Array).isRequired
  };

  state = {
    activeOption: 0,
    filteredOptions: [],
    showOptions: false,
    showAll: false,
    userInput: this.props.value    
  };

  onChange = (e) => {
    this.props.gameTitleChangeHandler(e.currentTarget.value);
    const { options } = this.props;
    const userInput = e.currentTarget.value;

    const filteredOptions = options.filter(
      (optionName) =>
        optionName.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

  this.setState({
      showAll: false,
      activeOption: 0,
      filteredOptions,
      showOptions: true,
      userInput: e.currentTarget.value
    });
  };

  setValue = (str) => {
    this.setState({
      userInput: str
    })
  }

  onClick = (e) => {
    this.props.gameTitleChangeHandler(e.currentTarget.innerText);
    this.setState({
      showAll: false,
      activeOption: 0,
      filteredOptions: [],
      showOptions: false,
      userInput: e.currentTarget.innerText
    });
  };
  onKeyDown = (e) => {
    const { activeOption, filteredOptions } = this.state;

    if (e.keyCode === 13) {
      this.setState({
        activeOption: 0,
        showOptions: false,
        userInput: filteredOptions[activeOption]
      });

      this.props.gameTitleChangeHandler(filteredOptions[activeOption]);
    } else if (e.keyCode === 38) {
      if (activeOption === 0) {
        return;
      }
      this.setState({ activeOption: activeOption - 1 });
    } else if (e.keyCode === 40) {
      if (activeOption === filteredOptions.length - 1) {
        return;
      }
      this.setState({ activeOption: activeOption + 1 });
    }

    this.setState({
      showAll: false
    })
  };

  onBlur = (e) => {
    // setTimeout(
    //     function() {
    //       this.setState({
    //         showOptions: false,
    //         showAll: false,
    //         filteredOptions: []
    //       })
    //     }
    //     .bind(this),
    //     100
    // );
  }

  closeDropDown() {
    this.setState({
      showOptions: false,
      showAll: false,
      filteredOptions: []
    })
  }

  onSubmit = (e) => {
    this.props.sendRequestGame(e);

    this.setState({
      showOptions: false
    })
  }

  showAllList() {
    if (this.state.filteredOptions.length) {
      this.nameInput.blur();

      this.setState({
        showAll: false,
        filteredOptions: []
      })
    } else {
      var options = this.props.options;

      if (this.state.userInput) {
        options = this.props.options.filter(
          (optionName) =>
            optionName.toLowerCase().indexOf(this.state.userInput.toLowerCase()) > -1
        );
      }

      this.setState({
        showAll: true,
        activeOption: 0,
        filteredOptions: options
      }, function(){
        this.nameInput.focus();
      })
    }
  }

  render() {
    const customStyle = {
      control: styles => ({ 
        ...styles,
        backgroundColor: 'white',
        color: 'black',
        border: 'solid 3px #ffd33f',
        borderRadius: '20px',
        paddingLeft: '7px',
        paddingRight: '7px',
        boxShadow: 'none',
        outline: 'none',
        "&:hover": {
          color: 'white',
          outline: 'none',
          boxShadow: 'none'
        },
        "&:focus": {
          color: 'white',
          outline: 'none',
          boxShadow: 'none'
        }
      }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
          backgroundColor: isFocused ? '#ddd' : 'white',
          color: isFocused ? 'black' : 'gray',
          padding: '10px 15px',
          size: 5,
          "&:hover": {
            border: 'none',
            boxShadow: 'none',
            outline: 'none'
          },
          "&:focus": {
            border: 'none',
            boxShadow: 'none',
            outline: 'none'
          }
        };
      },
      container: (base, state) => ({
        ...base,
        border: state.isFocused ? null : null,
        "&:hover": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        },
        "&:focus": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        }
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "black",
        "&:hover": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        },
        "&:focus": {
          border: 'none',
          boxShadow: 'none',
          outline: 'none'
        }
      })
    }

    const {
      onChange,
      onClick,
      onKeyDown,
      onSubmit,
      onBlur,

      state: { activeOption, filteredOptions, showOptions, userInput, showAll }
    } = this;

    const { placeholder } = this.props;
    
    let optionList;
    if ((showOptions && userInput) || showAll) {
      if (filteredOptions.length) {
        optionList = (
          <ul className="options">
            {filteredOptions.map((optionName, index) => {
                let className;
                if (index === activeOption) {
                  className = 'option-active';
                }
                return (
                  <li className={className} key={index} onClick={onClick}>
                    {optionName}
                  </li>
                );
              })
            }
          </ul>
        );
      } else {
        optionList = (
          <div className="no-options">
            <div className="game_request">
              <div className="form-group">
                <input className="gameTitle" name="Title" placeholder="Title" type="text" value={userInput} />
                <Select id="Genre" styles={customStyle} options={this.props.gameTypeList} onChange={this.props.changeGameTypeHandler} value={this.props.selectedGameType} placeholder={this.props.dataLanguage['genre']} />
              </div>
              <div className="text-right">
                <button className="btn_yellow" onClick={onSubmit}>{this.props.dataLanguage['request_game']}</button>
              </div>
            </div>
          </div>
        );
      }
    }
    return (
      <React.Fragment>
        <div className="search">
          <input
            ref={(input) => { this.nameInput = input; }} 
            type="text"
            className="search-box"
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            value={userInput}
            placeholder={placeholder}
          />
          <div className="triangle-out" onClick={this.showAllList.bind(this)}>
            <div className="triangle-container">
              <div className="triangle"></div>
            </div>
          </div>
        </div>
        {optionList}
      </React.Fragment>
    );
  }
}

export default Requestgame;



// WEBPACK FOOTER //
// ./src/components/Requestgame.js